export default "__VITE_ASSET__6a33a360__"